import $ from 'jquery';
import { removeBg } from './removeBg';
import { blurBg } from './blurBg';

export const initRemovebgListeners = async () => {
  $('body').on('click', '#editor-menu-image-removebg', removeBg);
  $('body').on('click', '#editor-menu-image-blurbg', blurBg);
};
